import { hasMissingReturnAddressFields } from "utils/returnAddress";
import React, { Fragment, useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Skeleton,
  TextField,
} from "@mui/material";
import {
  StyledAddressChange,
  StyledMob,
  StyledPickup,
  StyledShipping,
  StyledWeb,
} from "./styled";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getEncipherencode } from "utils/encipherencode";
import { useDispatch, useSelector } from "react-redux";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";
import { ReactComponent as CloseIcon } from "assets/close.svg";
import { useForm } from "react-hook-form";
import {
  addAddress,
  addShipmentMethod,
  getAddress,
} from "features/address/addresSlice";
import { toast } from "react-toastify";
import { addEmail, addPhone, getEmail } from "features/user/userSlice";
import { useTranslation } from "react-i18next";
import LoadingError from "components/v1/common/LoadingError";

export const PickupAddress = ({
  setAddressChange,
  edit,
  updatedAddress,
  disabled,
  serviceable,
  shipmentMethod,
  setShipmentMethod,
}) => {
  const { t } = useTranslation();
  const merchantConfig = useSelector(getMerchantConfig);
  const rmsConfig = useSelector(getRmsConfig);
  const location = useLocation();
  const formatShipmentMethod = (method) => {
    if (method === "merchant_handles_return_shipment") {
      return "Door Step Pickup";
    }
    if (method === "customer_ships_back") {
      return "Self Ship";
    }
    return method?.replaceAll("_", " ");
  };

  return (
    <StyledPickup>
      <div
        className="pickup"
        style={{
          justifyContent:
            location.pathname == "/return-cart" ? "space-between" : "center",
        }}
      >
        <span>
          {!disabled
            ? t("address.pickupAndDeliveryAddress")
            : t("address.deliveryAddress")}
        </span>
        {edit && (
          <p
            className="change"
            style={{
              textDecoration: "underline",
              cursor: "pointer",
              color: merchantConfig.primary_theme_color,
              marginLeft: "10px",
            }}
            onClick={() => setAddressChange(true)}
          >
            {t("common.actions.change")}
          </p>
        )}
      </div>
      <p
        className="pickup-address"
        style={{
          whiteSpace:
            location.pathname === "/tracking" ? "break-spaces" : "nowrap",
        }}
      >
        {updatedAddress && updatedAddress.addressLine1},{" "}
        {updatedAddress && updatedAddress.addressLine2}{" "}
        {updatedAddress && updatedAddress.addressLine2 && ","}{" "}
        {updatedAddress && updatedAddress.city} -{" "}
        {updatedAddress && updatedAddress.pincode},{" "}
        {updatedAddress && updatedAddress.state}
      </p>
      {((!rmsConfig.supports_return_pickup && rmsConfig.self_ship) ||
        !serviceable) && (
        <div
          style={{
            background: `${merchantConfig.primary_theme_color}33`,
            border: `1px dashed ${merchantConfig.primary_theme_color}`,
            padding: "6px",
            marginTop: "10px",
          }}
        >
          <p className="ship-back">
            {" "}
            {!serviceable &&
              !rmsConfig.show_shipping_preference &&
              t("address.notServiceable")}{" "}
            {t("address.shipBackTo")}
          </p>
          <p className="delivery-address">
            {rmsConfig.return_address?.name},{" "}
            {rmsConfig.return_address?.address_line_1},{" "}
            {rmsConfig.return_address?.address_line_2}{" "}
            {rmsConfig.return_address?.address_line_2 && ","}{" "}
            {rmsConfig.return_address?.city}, {rmsConfig.return_address?.state},{" "}
            {rmsConfig.return_address?.country}, -{" "}
            {rmsConfig.return_address?.pin}
          </p>
        </div>
      )}

      {rmsConfig.show_shipping_preference &&
        location.pathname === "/return-cart" && (
          <div className="customer-preference">
            <FormControl className="form-control-preference">
              <span className="title">Pickup Type:</span>
              <RadioGroup
                row
                aria-labelledby="shipping-option-type-buttons"
                name="shipping-option-type-buttons"
                value={shipmentMethod || ""}
                onChange={(event) => setShipmentMethod(event.target.value)}
              >
                {rmsConfig.supports_return_pickup && (
                  <FormControlLabel
                    id="1"
                    value="merchant_handles_return_shipment"
                    control={<Radio size="small" />}
                    label="Door Step Pickup"
                  />
                )}
                {!rmsConfig.supports_return_pickup && rmsConfig.self_ship && (
                  <FormControlLabel
                    id="2"
                    value="customer_ships_back"
                    control={<Radio size="small" />}
                    label="Self Ship"
                  />
                )}
              </RadioGroup>
            </FormControl>
          </div>
        )}

      {shipmentMethod && location.pathname === "/tracking" && (
        <p className="preference">
          Pickup Type:{" "}
          <span style={{ textTransform: "capitalize", fontWeight: "600" }}>
            {formatShipmentMethod(shipmentMethod)}
          </span>
        </p>
      )}
    </StyledPickup>
  );
};

function Address({
  allOrders,
  selectedOrder,
  addressLoader,
  serviceableCheck,
  setServiceableCheck,
  serviceability,
  checkServiceabilty,
  pincode,
  setPincode,
  serviceableLoader,
  setServiceableLoader,
  addressApiLoader,
  tempServiceablity,
  setTempServiceabilty,
  deliveryStatus,
}) {
  const { t } = useTranslation();
  const [addressChange, setAddressChange] = useState(false);

  const selectedItem = allOrders.filter(
    (a) => a.order_number === selectedOrder,
  );
  const merchantConfig = useSelector(getMerchantConfig);
  const rmsConfig = useSelector(getRmsConfig);

  const [state, setState] = useState(
    selectedItem[0].shipping_address?.province ||
      selectedItem[0].billing_address?.province || "",
  );
  const [city, setCity] = useState(
    selectedItem[0].shipping_address?.city ||
      selectedItem[0].billing_address?.city || "",
  );
  let initialLine1 = selectedItem[0].shipping_address?.address1 ||
    selectedItem[0].billing_address?.address1 || "";
  let initialLine2 = selectedItem[0].shipping_address?.address2 ||
    selectedItem[0].billing_address?.address2 || "";
  const [firstName, setFirstName] = useState(
    selectedItem[0].customer_first_name,
  );
  const [lastName, setLastName] = useState(selectedItem[0].customer_last_name);
  const [wrongAddress, setWrongAddress] = useState(false);
  const [wrongAddressStatement, setWrongAddressStatement] = useState(
    t("address.invalidFields"),
  );
  const [userInfoError, setUserInfoError] = useState(false);
  const updatedAddress = useSelector(getAddress);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const encipherencode = getEncipherencode(params);
  const { handleSubmit } = useForm();
  const format = /[\!\@\$\%\^\&\*\)\(\+\=\<\>\{\}\[\]\;\|\~\`\_\?]/;
  const sanitizeRegex = /[\!\@\$\%\^\&\*\)\(\+\=\<\>\{\}\[\]\;\|\~\`\_\?\/-]/g;

  initialLine1 = initialLine1.replace(sanitizeRegex, " ");
  initialLine2 = initialLine2.replace(sanitizeRegex, " ");
  const overflow = initialLine1.length > 80 ? initialLine1.slice(80) : "";
  const [addressLine1, setAddressLine1] = useState(initialLine1.slice(0, 80));
  const [addressLine2, setAddressLine2] = useState(initialLine2 + overflow);

  const missingEmail = useSelector(getEmail);

  const [userPhoneNumber, setUserPhoneNumber] = useState(
    selectedItem[0].user_phone_number,
  );
  const [userEmail, setUserEmail] = useState(
    missingEmail || selectedItem[0].user_email,
  );

  const handleAddressLine1Change = (value) => {
    let sanitized = value.replace(sanitizeRegex, " ");
    let newLine2 = addressLine2 ?? "";

    if (sanitized.length > 80) {
      const extra = sanitized.slice(80);
      sanitized = sanitized.slice(0, 80);
      newLine2 = (newLine2 ? newLine2 : "") + extra;
    }

    newLine2 = newLine2.replace(sanitizeRegex, " ");

    if ((sanitized + newLine2).length > 150) {
      setWrongAddress(true);
      setWrongAddressStatement(t("address.addressTooLong"));
    } else {
      setWrongAddress(false);
      setAddressLine1(sanitized);
      setAddressLine2(newLine2);
    }
  };

  const handleAddressLine2Change = (value) => {
    const sanitized = value.replace(sanitizeRegex, " ");
    if ((addressLine1 + sanitized).length > 150) {
      setWrongAddress(true);
      setWrongAddressStatement(t("address.addressTooLong"));
    } else {
      setWrongAddress(false);
      setAddressLine2(sanitized);
    }
  };

  const validateAddress = () => {
    const isValidAddressLine2 = addressLine2 ?? "";
    const totalLength = (addressLine1 + isValidAddressLine2).length;
    return (
      hasMissingReturnAddressFields({ pincode, state, city, addressLine1 }) ||
      format.test(pincode) ||
      format.test(addressLine1) ||
      format.test(addressLine2) ||
      format.test(state) ||
      format.test(city) ||
      addressLine1.length < 15 ||
      (isValidAddressLine2 !== "" &&
        (isValidAddressLine2.length < 10 || isValidAddressLine2.length > 70)) ||
      totalLength > 150
    );
  };

  const validateUpdatedAddress = (address) => {
    const isValidAddressLine2 = address.addressLine2 ?? "";
    const totalLength = (address.addressLine1 + isValidAddressLine2).length;
    if (
      (address?.addressLine1 || "").length < 15 ||
      (isValidAddressLine2 !== "" && isValidAddressLine2.length < 10)
    ) {
      setWrongAddressStatement(t("address.addressTooShort"));
    } else if (
      totalLength > 150 ||
      (isValidAddressLine2 !== "" && isValidAddressLine2.length > 70)
    ) {
      setWrongAddressStatement(t("address.addressTooLong"));
    }
    return (
      hasMissingReturnAddressFields(address) ||
      format.test(address.pincode) ||
      format.test(address.addressLine1) ||
      format.test(address.addressLine2) ||
      format.test(address.state) ||
      format.test(address.city) ||
      (address?.addressLine1 || "").length < 15 ||
      (isValidAddressLine2 !== "" &&
        (isValidAddressLine2.length < 10 || isValidAddressLine2.length > 70)) ||
      totalLength > 150
    );
  };
  useEffect(() => {
    if (selectedItem !== null) {
      setPincode(
        selectedItem[0].shipping_address?.zip ||
          selectedItem[0].billing_address?.zip || "",
      );
      if (validateUpdatedAddress(updatedAddress)) {
        setAddressChange(true);
        setWrongAddress(true);
      } else if (
        !(
          userEmail !== undefined &&
          userPhoneNumber !== undefined &&
          userEmail !== null &&
          userPhoneNumber !== null &&
          userEmail !== "" &&
          userPhoneNumber !== "" &&
          firstName &&
          lastName &&
          firstName !== null &&
          lastName !== null &&
          firstName !== "" &&
          lastName !== ""
        )
      ) {
        setAddressChange(true);
        setUserInfoError(true);
      }
    } else {
      setWrongAddress(false);
      setAddressChange(false);
      setUserInfoError(false);
    }
  }, [selectedItem[0], updatedAddress]);

  const addressHandler = () => {
    if (!validateAddress()) {
      setAddressChange(false);
      setServiceableCheck(tempServiceablity);
      dispatch(
        addAddress({
          ...updatedAddress,
          pincode,
          firstName,
          lastName,
          addressLine1,
          addressLine2,
          state,
          city,
        }),
      );
      dispatch(addPhone(userPhoneNumber));
      dispatch(addEmail(userEmail));
      setWrongAddress(false);
      setUserInfoError(false);
    } else {
      toast.error(t("address.noSpecialCharactersAllowed"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    }
  };

  useEffect(() => {
    setTempServiceabilty(serviceableCheck);
  }, [serviceableCheck]);

  const shipmentHandler = (shipment) => {
    dispatch(addShipmentMethod(shipment));
    dispatch(
      addAddress({
        pincode,
        firstName,
        lastName,
        addressLine1,
        addressLine2,
        state,
        city,
      }),
    );
  };

  const ShippingPreference = () => {
    return (
      <StyledShipping>
        {serviceableCheck || rmsConfig.self_ship ? (
          <Fragment>
            {serviceableCheck ? (
              <Fragment>
                <div style={{ textAlign: "center" }}>
                  <p style={{ color: "#3B444DB2" }}>
                    Your PIN Code ({pincode}) is eligibile for pickup and
                    delivery
                  </p>

                  <div style={{ marginTop: "20px" }}>
                    <p>
                      Your pickup and delivery address{" "}
                      <span
                        style={{
                          color: "#1d8dcc",
                          textDecoration: "underline",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setAddressChange(true)}
                      >
                        Change
                      </span>
                    </p>
                    <p
                      className="address"
                      style={{ color: "#3B444DB2", marginTop: "5px" }}
                    >
                      {updatedAddress && updatedAddress.addressLine1},{" "}
                      {updatedAddress && updatedAddress.addressLine2}{" "}
                      {updatedAddress && updatedAddress.addressLine2 && ","}{" "}
                      {updatedAddress && updatedAddress.city} -{" "}
                      {updatedAddress && updatedAddress.pincode},{" "}
                      {updatedAddress && updatedAddress.state}
                    </p>
                  </div>
                </div>
              </Fragment>
            ) : (
              rmsConfig.self_ship && (
                <Fragment>
                  <div style={{ textAlign: "center" }}>
                    <p style={{ color: "#3B444DB2", lineHeight: "25px" }}>
                      Your PIN Code ({pincode}) is not eligibile for pickup.{" "}
                      <span
                        style={{
                          color: "#1d8dcc",
                          textDecoration: "underline",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => setAddressChange(true)}
                      >
                        Change
                      </span>
                    </p>

                    <div
                      style={{
                        background: "#3B444D1A",
                        borderRadius: "10px",
                        padding: "25px",
                        marginTop: "20px",
                      }}
                    >
                      <p style={{ color: "#3B444D", fontWeight: "500" }}>
                        Please ship products back to company's warehouse.
                      </p>
                      <p
                        style={{
                          color: "#3B444D",
                          marginTop: "10px",
                          fontSize: "12px",
                        }}
                      >
                        ( Address will be sent to you on +91-
                        {selectedItem[0].user_phone_number} )
                      </p>
                    </div>
                  </div>
                </Fragment>
              )
            )}
          </Fragment>
        ) : (
          <p
            style={{
              color: "#3B444DB2",
              lineHeight: "1.75",
              width: "100%",
            }}
          >
            Sorry :( We cannot arrange for a return pickup as pincode is not
            serviceable.
          </p>
        )}
      </StyledShipping>
    );
  };

  return (
    <div style={{ position: "relative" }}>
      {addressLoader ? (
        <div className="address-skeleton">
          <Skeleton variant="text" height={50} />
          <Skeleton variant="text" height={50} />
          <Skeleton variant="text" height={50} />
          <Skeleton variant="text" height={50} />
        </div>
      ) : deliveryStatus ? (
        <Fragment>
          <StyledWeb>
            {addressApiLoader ? (
              <LoadingError marginTop="100px" />
            ) : (
              <ShippingPreference />
            )}
            <Button
              variant="contained"
              color="primary"
              style={{
                fontWeight: "500",
                textTransform: "capitalize",
              }}
              disabled={userInfoError || wrongAddress}
              onClick={() => {
                shipmentHandler(
                  serviceableCheck
                    ? "merchant_handles_return_shipment"
                    : "customer_ships_back",
                );
                let url = "/products";
                if (encipherencode) {
                  url += `?encipherencode=${encipherencode}`;
                }
                navigate(url);
              }}
            >
              Continue
            </Button>
            <p
              style={{
                color: "#3B444D55",
                fontSize: "12px",
                marginTop: "10px",
              }}
            >
              *Charges may apply
            </p>
          </StyledWeb>

          {/*  Address Change */}

          {addressChange && (
            <StyledAddressChange serviceableCheck={serviceableCheck}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.08)",
                  height: "80px",
                  padding: "32px",
                }}
              >
                <p
                  style={{
                    fontSize: "1rem",
                    fontWeight: "500",
                    color: "#3B444D",
                  }}
                >
                  Your Pickup & Delivery Address
                </p>
                <p
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!format.test()) {
                      toast.error(t("address.fillAllFields"), {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                      });
                    } else if (
                      (!validateAddress() && wrongAddress) ||
                      !wrongAddress
                    ) {
                      setAddressChange(false);
                      dispatch(
                        addAddress({
                          ...updatedAddress,
                          pincode: updatedAddress.pincode,
                          firstName: updatedAddress.firstName,
                          lastName: updatedAddress.lastName,
                          addressLine1: updatedAddress.addressLine1,
                          addressLine2: updatedAddress.addressLine2,
                          state: updatedAddress.state,
                          city: updatedAddress.city,
                        }),
                      );
                      dispatch(addPhone(userPhoneNumber));
                      dispatch(addEmail(userEmail));
                      setPincode(updatedAddress.pincode);
                      setTempServiceabilty(serviceableCheck);
                    } else {
                      toast.error(t("address.invalidFieldsShort"), {
                        position: toast.POSITION.TOP_RIGHT,
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                      });
                    }
                  }}
                >
                  {" "}
                  <CloseIcon
                    style={{ width: "24px", height: "24px", stroke: "#3B444D" }}
                  />{" "}
                </p>
              </div>
              {wrongAddress && (
                <div style={{ padding: "20px 24px 0px" }}>
                  <p
                    style={{
                      color: "red",
                      padding: "10px 15px",
                      border: "1px solid red",
                      background: "#f4b3b3",
                      marginBottom: "0px",
                      borderRadius: "4px",
                    }}
                  >
                    {wrongAddressStatement}
                  </p>
                </div>
              )}
              {userInfoError && (
                <div style={{ padding: "20px 24px 0px" }}>
                  <p
                    style={{
                      color: "red",
                      padding: "10px 15px",
                      border: "1px solid red",
                      background: "#f4b3b3",
                      marginBottom: "0px",
                      borderRadius: "4px",
                    }}
                  >
                    Please fill all the fields
                  </p>
                </div>
              )}
              <form
                onSubmit={handleSubmit(addressHandler)}
                style={{ margin: "20px 0px", padding: "0px 32px" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    overflowY: "auto",
                  }}
                >
                  <TextField
                    name="pincode"
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                    variant="outlined"
                    label={t("address.labels.pinCode")}
                    defaultValue={
                      selectedItem[0].shipping_address?.zip ||
                      selectedItem[0].billing_address?.zip
                    }
                    inputProps={{ type: "text" }}
                    style={{ marginTop: "20px" }}
                  />
                  <p
                    style={{
                      fontSize: "14px",
                      color: "#111",
                      marginLeft: "20px",
                      cursor: "pointer",
                      marginTop: "6px",
                    }}
                    onClick={() => {
                      setServiceableLoader(true);
                      checkServiceabilty(pincode, true);
                      setAddressLine1(null);
                      setAddressLine2(null);
                      setState(null);
                      setCity(null);
                    }}
                  >
                    Check serviceability
                  </p>
                </div>

                {serviceableLoader ? (
                  <div style={{ marginTop: "40px" }}>
                    <Skeleton height={75} />
                    <Skeleton height={75} />
                    <Skeleton height={75} />
                  </div>
                ) : (
                  serviceability && (
                    <Fragment>
                      {tempServiceablity ? (
                        <p
                          style={{
                            color: "#3B444DB2",
                            lineHeight: "1.75",
                            width: "100%",
                            margin: "20px 0px",
                            fontSize: "14px",
                          }}
                        >
                          {" "}
                          Yayy ! Your PIN Code is eligible for pickup and
                          delivery. <br />
                        </p>
                      ) : (
                        <p
                          style={{
                            color: "#3B444D",
                            lineHeight: "1.75",
                            width: "100%",
                            margin: "20px 0px",
                            fontSize: "14px",
                          }}
                        >
                          Your PIN Code is ineligible for pickup of products.{" "}
                          <br />
                          Please provide address for delivery.{" "}
                        </p>
                      )}
                      <div style={{ display: "flex" }}>
                        <TextField
                          name="state"
                          variant="outlined"
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                          label={t("address.labels.state")}
                          required
                          fullWidth
                          inputProps={{ type: "text" }}
                          style={{ marginTop: "20px" }}
                        />
                        <TextField
                          name="city"
                          variant="outlined"
                          onChange={(e) => setCity(e.target.value)}
                          label={t("address.labels.city")}
                          value={city}
                          required
                          fullWidth
                          inputProps={{ type: "text" }}
                          style={{ marginTop: "20px", marginLeft: "10px" }}
                        />
                      </div>
                      <div style={{ display: "flex" }}>
                        <TextField
                          name="first_name"
                          variant="outlined"
                          onChange={(e) => setFirstName(e.target.value)}
                          label={t("address.labels.firstName")}
                          value={firstName}
                          required
                          fullWidth
                          inputProps={{ type: "text" }}
                          style={{ marginTop: "20px" }}
                        />
                        <TextField
                          name="last_name"
                          variant="outlined"
                          onChange={(e) => setLastName(e.target.value)}
                          label={t("address.labels.lastName")}
                          value={lastName}
                          required
                          fullWidth
                          inputProps={{ type: "text" }}
                          style={{ marginTop: "20px", marginLeft: "10px" }}
                        />
                      </div>
                      <div style={{ display: "flex" }}>
                        <TextField
                          name="email"
                          variant="outlined"
                          value={userEmail}
                          onChange={(e) => {
                            setUserEmail(e.target.value);
                          }}
                          label={t("address.labels.email")}
                          required
                          fullWidth
                          inputProps={{ type: "email" }}
                          style={{ marginTop: "20px" }}
                        />
                        <TextField
                          name="phone_number"
                          variant="outlined"
                          value={userPhoneNumber}
                          disabled={
                            userPhoneNumber &&
                            userPhoneNumber !== null &&
                            userPhoneNumber.length > 9
                              ? true
                              : false
                          }
                          onChange={(e) => {
                            setUserPhoneNumber(e.target.value);
                          }}
                          label={t("address.labels.phoneNumber")}
                          required
                          fullWidth
                          inputProps={{ type: "text" }}
                          style={{ marginTop: "20px", marginLeft: "10px" }}
                        />
                      </div>
                      <TextField
                        name="address_line1"
                        variant="outlined"
                        onChange={(e) =>
                          handleAddressLine1Change(e.target.value)
                        }
                        label={t("address.labels.addressLine1")}
                        value={addressLine1}
                        required
                        fullWidth
                        defaultValue=""
                        inputProps={{ type: "text" }}
                        style={{ marginTop: "20px" }}
                      />
                      <TextField
                        name="address_line2"
                        variant="outlined"
                        onChange={(e) =>
                          handleAddressLine2Change(e.target.value)
                        }
                        label={t("address.labels.addressLine2")}
                        value={addressLine2}
                        fullWidth
                        defaultValue=""
                        inputProps={{ type: "text" }}
                        style={{ marginTop: "20px" }}
                      />

                      <Button
                        color="primary"
                        type="submit"
                        style={{
                          padding: "1rem",
                          borderRadius: !merchantConfig.use_rounded_edge_buttons
                            ? "0px"
                            : "4px",
                          margin: "40px auto",
                          display: "block",
                          border: `1px solid ${merchantConfig.primary_theme_color}80`,
                          cursor: "pointer",
                          textTransform: "capitalize",
                        }}
                      >
                        {userInfoError
                          ? t("common.actions.saveAndContinue")
                          : t("common.actions.saveAddress")}
                      </Button>
                    </Fragment>
                  )
                )}
              </form>
            </StyledAddressChange>
          )}

          <StyledMob>
            <div style={{ padding: "0px 15px", marginTop: "20px" }}>
              {addressApiLoader ? (
                <LoadingError marginTop="80px" />
              ) : (
                <ShippingPreference />
              )}
            </div>
            <Button
              variant="contained"
              color="primary"
              style={{
                margin: "10px auto",
                display: "block",
                fontWeight: "500",
                textTransform: "capitalize",
              }}
              disabled={userInfoError || wrongAddress}
              onClick={() => {
                shipmentHandler(
                  serviceableCheck
                    ? "merchant_handles_return_shipment"
                    : "customer_ships_back",
                );
                let url = "/products";
                if (encipherencode) {
                  url += `?encipherencode=${encipherencode}`;
                }
                navigate(url);
              }}
            >
              Continue
            </Button>
            <p
              style={{
                color: "#3B444D55",
                fontSize: "12px",
                marginTop: "10px",
              }}
            >
              *Charges may apply
            </p>
          </StyledMob>
        </Fragment>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "80vh",
            justifyContent: "center",
            fontSize: "1rem",
            color: "#3B444D",
            padding: "0px 20px",
          }}
        >
          <p style={{ textAlign: "center", lineHeight: "1.25" }}>
            Looks like your order is not delivered yet.
          </p>
          <p
            style={{
              marginTop: "10px",
              textAlign: "center",
              lineHeight: "1.25",
            }}
          >
            Please try to initiate a{" "}
            {rmsConfig.only_replacement ? "replace" : "exchange/return"} request
            after the order is delivered!
          </p>
        </div>
      )}
    </div>
  );
}

export default Address;
